<template>
  <div>
    <FavoriteBybit
      @period-selected="handleSearch"
      @refresh-clicked="handleRefresh"
      @handle-fetchCoins="fetchCoins"
      @metrics-changed="handleMetrics"
      @coins-loaded="handleCoinsLoaded"
    />
    <template v-if="selectedMetrics.length">
      <div
        v-for="index in totalChart"
        :key="'chart-grid-' + index"
        class="chart-grid"
      >
        <div class="chart-header text-center">
          <h3>
            Biểu đồ
            {{
              typeof arrayCoin[index - 1] === "object"
                ? arrayCoin[index - 1]?.coinName
                : arrayCoin[index - 1]
            }}
            <span
              v-if="typeof arrayCoin[index - 1] === 'object' && arrayCoin[index - 1]?.monitoringFlag === 'Y'"
              class="monitoring-badge"
            >
              Monitoring
            </span>
          </h3>

        </div>

        <div class="chart-box">
          <div
            class="chart-container first-chart"
            v-if="selectedMetrics.includes('openInterest')"
          >
            <canvas
              :id="chartIds[index - 1]"
              :key="chartIds[index - 1]"
              :ref="'chart' + (index - 1)"
            ></canvas>
          </div>

          <div
            class="chart-container second-chart"
            v-if="selectedMetrics.includes('longShort')"
          >
            <canvas
              :id="secondChartIds[index - 1]"
              :key="secondChartIds[index - 1]"
              :ref="'second-chart' + (index - 1)"
            ></canvas>
          </div>

          <div
            class="chart-container third-chart"
            v-if="selectedMetrics.includes('longShort')"
          >
            <canvas
              :id="thirdChartIds[index - 1]"
              :key="thirdChartIds[index - 1]"
              :ref="'third-chart' + (index - 1)"
            ></canvas>
          </div>


        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { API_URL } from "../config";
import {
  Chart as ChartJS,
  CategoryScale,
  TimeScale,
  BarController,
  BarElement,
  LinearScale,
  LineElement,
  PointElement,
  LineController,
  Title,
  Tooltip,
  Legend,
  Filler,
  SubTitle,
} from "chart.js";
import "chartjs-adapter-date-fns";
import '@/assets/css/bybit.css'
import "vue-select/dist/vue-select.css";
import ChartDataLabels from "chartjs-plugin-datalabels";
import FavoriteBybit from './favorite/FavoriteBybit.vue'
ChartJS.register(
  CategoryScale,
  SubTitle,
  TimeScale,
  BarController,
  BarElement,
  LinearScale,
  LineElement,
  PointElement,
  LineController,
  ChartDataLabels,
  Title,
  Tooltip,
  Legend,
  Filler
);
const nfComma = new Intl.NumberFormat('en-US');
function fmtComma(n, frac = 0) {
  if (!Number.isFinite(n)) return '-';
  return nfComma.format(frac ? Number(n).toFixed(frac) : Math.round(n));
}
function niceMinMax(arr, pad = 0.06) {
  const vals = (arr || []).filter(Number.isFinite);
  if (!vals.length) return { min: 0, max: 1 };
  let min = Math.min(...vals);
  let max = Math.max(...vals);
  if (min === max) {
    const bump = Math.abs(min) || 1;
    return { min: min - bump * pad, max: max + bump * pad };
  }
  const range = max - min;
  return { min: min - range * pad, max: max + range * pad };
}
const shadowLine = {
  id: 'shadowLine',
  afterDatasetsDraw(chart) {
    const { ctx, data } = chart
    const meta = chart.getDatasetMeta(1)
    if (!meta || !meta.dataset) return
    ctx.save()
    ctx.shadowColor = 'rgba(0,0,0,0.7)'
    ctx.shadowBlur = 6
    ctx.shadowOffsetY = 2
    ctx.lineWidth = 2
    ctx.strokeStyle = '#ffffff'
    ctx.beginPath()
    meta.dataset.draw(ctx, data)
    ctx.restore()
  }
}
const stripeBg = {
  id: 'stripeBgLight',
  beforeDraw(chart) {
    const y = chart.scales?.y;
    const area = chart.chartArea;
    if (!y || !y.ticks?.length || !area) return;

    const { ctx, chartArea: { left, right, top, bottom } } = chart;

    ctx.save();
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(left, top, right - left, bottom - top);

    for (let i = 0; i < y.ticks.length - 1; i++) {
      if (i % 2 === 0) {
        const y1 = y.getPixelForTick(i);
        const y2 = y.getPixelForTick(i + 1);
        ctx.fillStyle = 'rgba(0,0,0,0.035)';
        ctx.fillRect(left, y2, right - left, y1 - y2);
      }
    }
    ctx.restore();
  }
};
ChartJS.register(shadowLine)
export default {
  name: "BybitCoin",
  components: {
    FavoriteBybit
  },
  data() {
    return {
      selectedCoin: null,
      chartIds: Array.from({ length: 30 }, (_, i) => `chart-${i}`),
      secondChartIds: Array.from({ length: 30 }, (_, i) => `second-chart-${i}`),
      thirdChartIds: Array.from({ length: 30 }, (_, i) => `third-chart-${i}`),
      coinNames: Array(20).fill(""),
      periods: "",
      selectedMetrics: ['openInterest','longShort'],
      initialMetrics: ['openInterest','longShort'],
      charts: [],
      secondCharts: [],
      thirdCharts: [],
      chartDataSets: [],
      secondChartDataSets: [],
      thirdChartDataSets: [],
      loading: false,
      coins: [],
      totalChart: 0,
      arrayCoin: [],
      displayedCoins: [],
    };
  },
  async created() {
    // Không gọi fetchCoins ở đây nữa vì con (FavoriteBybit) sẽ lo việc này khi nó khởi tạo
  },
  methods: {
    getCoinName(coinItem) {
      if (typeof coinItem === "string") {
        return coinItem;
      }
      return coinItem?.coinName || "BTC";
    },


    handleCoinsLoaded(data) {
      console.log("📦 Bybit Parent received coins-loaded event");
      this.processCoinsData(data);
    },

    processCoinsData(data) {
      this.coins = data.map((coin) => ({
        id: coin.id,
        coinName: `${coin.coinName}USDT`,
        favoriteFlag: coin.favoriteFlag,
        monitoringFlag: coin.monitoringFlag,
      }));
      const allCoins = this.coins
        .map((coin) => ({ ...coin, isSelected: coin.favoriteFlag === "1" }))
        .sort((a, b) => b.isSelected - a.isSelected);
      this.coinNames = allCoins
        .slice(0, 20)
        .map((coin) => {
          if (coin.isSelected) {
            return {
              coinName: coin.coinName,
              monitoringFlag: coin.monitoringFlag
            };
          }
          return "";
        });
      this.coinNames = [
        ...this.coinNames,
        ...Array(20 - this.coinNames.length).fill(""),
      ];
      this.displayedCoins = allCoins.slice(0, 20);
    },

    async fetchCoins() {
      try {
        const response = await fetch(`${API_URL}/bybit/get-coins`);
        const data = await response.json();
        this.processCoinsData(data);
      } catch (error) {
        console.error("Error fetching coins:", error);
      }
    },


    async handleSearch(period) {
      this.periods = period
      if (this.periods == "") {
        this.$toast.open({
          message: 'Vui lòng chọn thời gian!',
          type: 'error',
          position: 'top-right',
        });
        return false
      }
      const loading = this.$loading.show();

      // Cập nhật danh sách coin từ API (để lấy monitoringFlag mới nhất)
      await this.fetchCoins();

      const filteredArray = this.coinNames
        .filter((item) => item != null && item !== "");
      this.coinNames = filteredArray;

      for (let i = 0; i < filteredArray.length; i++) {
        this.loading = true;
        const jobs = [];
        // Khi chọn time frame, luôn gen tất cả chart (bỏ qua kiểm tra metrics)
        const coinName = typeof this.coinNames[i] === "string" ? this.coinNames[i] : this.coinNames[i].coinName;
        jobs.push(this.fetchNotionalData(coinName, i, this.periods));
        jobs.push(
          this.fetchSecondApiDataForCoin(coinName, i, this.periods),
          this.fetchThirdApiDataForCoin(coinName, i, this.periods)
        );
        await Promise.all(jobs);
      }
      this.totalChart = filteredArray.length;
      this.loading = false;
      this.arrayCoin = this.coinNames;
      this.createCharts();
      loading.hide();
    },

    async handleRefresh(period) {
      this.periods = period
      if (this.periods == "") {
        this.$toast.open({
          message: 'Vui lòng chọn thời gian!',
          type: 'error',
          position: 'top-right',
        });
        return false
      }
      const loading = this.$loading.show();

      // Cập nhật danh sách coin từ API (để lấy monitoringFlag mới nhất)
      await this.fetchCoins();

      const filteredArray = this.coinNames
        .filter((item) => item != null && item !== "");
      this.coinNames = filteredArray;

      for (let i = 0; i < filteredArray.length; i++) {
        this.loading = true;
        const jobs = [];
        const sel = new Set(this.selectedMetrics);
        // Lấy coinName từ object nếu là object, nếu không thì dùng trực tiếp
        const coinName = typeof this.coinNames[i] === "string" ? this.coinNames[i] : this.coinNames[i].coinName;
        // Khi refresh, chỉ gen chart cho metrics đã chọn
        if (sel.has('openInterest')) jobs.push(this.fetchNotionalData(coinName, i, this.periods));
        if (sel.has('longShort')) {
          jobs.push(
            this.fetchSecondApiDataForCoin(coinName, i, this.periods),
            this.fetchThirdApiDataForCoin(coinName, i, this.periods)
          );
        }
        await Promise.all(jobs);
      }
      this.totalChart = filteredArray.length;
      this.loading = false;
      this.arrayCoin = this.coinNames;
      this.createCharts();
      loading.hide();
    },

    async fetchNotionalData(coinName, index, period) {
      try {
        const requestBody = {
          name: coinName,
          periodMinutes: period,
        };

        const res = await fetch(`${API_URL}/bybit/open-interest`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody),
        });

        if (!res.ok) {
          const text = await res.text().catch(() => '');
          throw new Error(`HTTP ${res.status} ${res.statusText} - ${text}`);
        }

        const raw = await res.json();

        // Xử lý response từ Bybit API
        // Format: { ret_code: 0, result: { tradingMetricsList: [...] } }
        const list = raw?.result?.tradingMetricsList || [];

        if (!Array.isArray(list) || list.length === 0) {
          console.warn('Payload rỗng hoặc sai định dạng:', raw);
          this.chartDataSets[index] = [];
          return;
        }

        const sorted = [...list].sort((a, b) => Number(a.timestamp) - Number(b.timestamp));
        const result = sorted.map(item => ({
          x: Number(item.timestamp),
          oi: Number(item.oi),
          notional: Number(item.oiInUSDT),
        }));

        this.chartDataSets[index] = result;
      } catch (error) {
        console.error(`Lỗi khi tải dữ liệu từ API mới cho ${coinName}:`, error?.message || error);
        this.chartDataSets[index] = [];
      }
    },

    async fetchSecondApiDataForCoin(coinName, index, period) {
      try {
        const requestBody = {
          symbol: coinName,
          period: period,
          limit: 30,
        };

        const response = await fetch(
          `${API_URL}/bybit/longshort-acc`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestBody),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const raw = await response.json();

        // Xử lý response từ Bybit API
        // Format: { ret_code: 0, result: { holderPosList: [...] } }
        const list = raw?.result?.holderPosList || [];

        if (!Array.isArray(list) || list.length === 0) {
          console.warn('Payload rỗng hoặc sai định dạng:', raw);
          this.secondChartDataSets[index] = [];
          return;
        }

        const sorted = [...list].sort((a, b) => Number(a.timestamp) - Number(b.timestamp));
        const result = sorted.map((item) => ({
          x: Number(item.timestamp),
          y: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
          longPercent: parseFloat(item.longPosRatio) * 100,
          shortPercent: parseFloat(item.shortPosRatio) * 100,
          longShortRatio: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
        }));

        this.secondChartDataSets[index] = result;
      } catch (error) {
        console.error(
          `Lỗi khi tải dữ liệu từ API Long/Short Accounts cho ${coinName}:`,
          error.message || error
        );
        this.secondChartDataSets[index] = [];
      }
    },

    async fetchThirdApiDataForCoin(coinName, index, period) {
      try {
        const requestBody = {
          symbol: coinName,
          period: period,
          limit: 30,
        };

        const response = await fetch(
          `${API_URL}/bybit/longshort-poss`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestBody),
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const raw = await response.json();

        // Xử lý response từ Bybit API
        // Format: { ret_code: 0, result: { topHolderPosList: [...] hoặc holderPosList: [...] } }
        const list = raw?.result?.topHolderPosList || raw?.result?.holderPosList || [];

        if (!Array.isArray(list) || list.length === 0) {
          console.warn('Payload rỗng hoặc sai định dạng:', raw);
          this.thirdChartDataSets[index] = [];
          return;
        }

        const sorted = [...list].sort((a, b) => Number(a.timestamp) - Number(b.timestamp));
        const result = sorted.map((item) => ({
          x: Number(item.timestamp),
          y: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
          longPercent: parseFloat(item.longPosRatio) * 100,
          shortPercent: parseFloat(item.shortPosRatio) * 100,
          longShortRatio: parseFloat(parseFloat(item.longShortRatio || 0).toFixed(3)),
        }));

        this.thirdChartDataSets[index] = result;
      } catch (error) {
        console.error(
          `Lỗi khi tải dữ liệu từ API Long/Short Positions cho ${coinName}:`,
          error.message || error
        );
        this.thirdChartDataSets[index] = [];
      }
    },


    createCharts() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const kill = c => { try { c && !c._destroyed && c.destroy(); } catch (_) { /* ignore */ } };
          [this.charts, this.secondCharts, this.thirdCharts]
            .forEach(arr => {
              (arr || []).forEach((c, i) => {
                const cv = c?.canvas;
                if (!cv || !document.body.contains(cv)) { kill(c); arr[i] = null; }
              });
            });
          let periods = this.periods;
          this.chartIds.slice(0, this.totalChart).forEach((chartId, index) => {
            const canvas = document.getElementById(chartId);
            if (canvas) {
              if (!canvas) return;
              if (canvas.offsetParent === null) return;
              const exist = ChartJS.getChart(canvas);
              if (exist) {
                try { exist.destroy(); } catch (e) {
                  // skip
                }
              }
              const ctx = canvas.getContext("2d");
              if (!ctx) return;
              if (this.charts[index]) {
                try { this.charts[index].destroy(); } catch (e) {
                  // skip
                }
                this.charts[index] = null;
              }
              const dataSet = this.chartDataSets[index] || [];
              const labels = dataSet.map(item => item.x);
              const oi = dataSet.map(item => item.oi);
              const notional = dataSet.map(item => item.notional);

              const yL = niceMinMax(oi, 0.06);
              const yR = niceMinMax(notional, 0.06);
              const LEFT_TICKS  = 4;
              const RIGHT_TICKS = 4;
              const leftStep  = (yL.max - yL.min) / Math.max(1, LEFT_TICKS - 1);
              const rightStep = (yR.max - yR.min) / Math.max(1, RIGHT_TICKS - 1);

              this.charts[index] = new ChartJS(ctx, {
                type: "bar",
                data: {
                  labels,
                  datasets: [
                    {
                      type: 'bar',
                      label: `Open Interest (${this.getCoinName(this.coinNames[index]).replace('USDT', '')})`,
                      data: oi,
                      yAxisID: 'y',
                      backgroundColor: '#f0b90b',
                      borderColor: '#dca600',
                      borderSkipped: false,
                      borderWidth: 0,
                      borderRadius: 2,
                      barPercentage: 0.6,
                      categoryPercentage: 0.8,
                      maxBarThickness: 12,
                      datalabels: { display: false },
                      order: 1
                    },
                    {
                      type: 'line',
                      label: 'Notional Value of Open Interest (USDT)',
                      data: notional,
                      yAxisID: 'y1',
                      borderColor: '#ffffff',
                      borderWidth: 2,
                      order: 999,
                      z: 10,
                      showLine: true,
                      spanGaps: true,
                      pointRadius: 2,
                      pointHoverRadius: 3,
                      pointBackgroundColor: '#0b1220',
                      pointBorderColor: '#e5e7eb',
                      pointBorderWidth: 1,
                      tension: 0.25,
                      cubicInterpolationMode: 'monotone',
                      fill: false,
                      datalabels: { display: false }
                    }
                  ],
                },
                options: {
                  responsive: true,
                  maintainAspectRatio: false,
                  layout: { padding: 0 },
                  interaction: {
                    mode: 'index',
                    intersect: false
                  },
                  plugins: {
                    legend: {
                      display: true,
                      reverse: false
                    },
                    datalabels: {
                      display: false,
                    },
                    title: {
                      display: true,
                      text: `Open Interest(${this.getCoinName(this.coinNames[index])})`,
                    },
                    tooltip: {
                      backgroundColor: '#111827',
                      borderColor: '#374151',
                      borderWidth: 1,
                      titleColor: '#e5e7eb',
                      bodyColor: '#e5e7eb',
                      callbacks: {
                        title(items) {
                          const ts = items[0]?.parsed.x;
                          return ts ? new Date(ts).toLocaleTimeString() : '';
                        },
                        label(c) {
                          const name = c.dataset.label;
                          const value = c.parsed.y;
                          return ` ${name}: ${fmtComma(value)}`;
                        }
                      }
                    },
                  },
                  scales: {
                    x: {
                      type: 'time',
                      time: {
                        unit: this.periods === "1h" || this.periods === "4h" ? "hour"
                            : this.periods === "1d" ? "day" : "minute"
                      },
                      grid: {
                        color: 'rgba(255,255,255,0.10)',
                        drawTicks: true,
                        drawOnChartArea: true
                      },
                      offset: false,
                      bounds: 'data',
                      ticks: {
                        color: '#9ca3af',
                        maxTicksLimit: 15,
                        count: 15,
                        autoSkip: true,
                        autoSkipPadding: 8,

                        maxRotation: 55,
                        minRotation: 35,
                        padding: 2,

                        callback: function (value) {
                          const date = new Date(value);
                          if (periods === "1d") {
                            return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" });
                          } else {
                            return date.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
                          }
                        },
                      },
                    },
                    y: {
                      position: 'left',
                      min: yL.min,
                      max: yL.max,
                      beginAtZero: false,
                      grid: { color: 'rgba(255,255,255,0.10)', drawOnChartArea: true, drawTicks: true },
                      ticks: {
                        color: '#9ca3af', font: { size: 11 }, padding: 0, count: LEFT_TICKS, stepSize: leftStep,
                        callback: function (v) {
                          const a = Math.abs(v);
                          if (a >= 1e12) return (v / 1e12).toFixed(0) + 'T';
                          if (a >= 1e9) return (v / 1e9).toFixed(0) + 'B';
                          if (a >= 1e6) return (v / 1e6).toFixed(0) + 'M';
                          if (a >= 1e3) return (v / 1e3).toFixed(0) + 'K';
                          return Math.round(v);
                        }
                      },
                      title: { display: false }
                    },
                    y1: {
                      position: 'right',
                      min: yR.min,
                      max: yR.max,
                      beginAtZero: false,
                      grid: { display: false, drawOnChartArea: false },
                      ticks: {
                        color: '#9ca3af', font: { size: 11 }, padding: 0, count: RIGHT_TICKS, stepSize: rightStep,
                        callback: function (v) {
                          const a = Math.abs(v);
                          if (a >= 1e12) return (v / 1e12).toFixed(0) + 'T';
                          if (a >= 1e9) return (v / 1e9).toFixed(0) + 'B';
                          if (a >= 1e6) return (v / 1e6).toFixed(0) + 'M';
                          if (a >= 1e3) return (v / 1e3).toFixed(0) + 'K';
                          return Math.round(v);
                        }
                      },
                      title: { display: false }
                    }
                  }
                },
                plugins: [stripeBg]
              });
              if (canvas && canvas.parentNode) {
                canvas.parentNode.style.height = '300px';
              }
            }
          });

          this.secondChartIds
            .slice(0, this.totalChart)
            .forEach((chartId, index) => {
              const canvas = document.getElementById(chartId);
              if (!canvas) return;
              if (canvas.offsetParent === null) return;
              const exist = ChartJS.getChart(canvas);
              if (exist) {
                try { exist.destroy(); } catch (e) {
                  // skip
                }
              }
              const ctx = canvas.getContext("2d");
              if (!ctx) return;
              if (canvas) {
                if (this.secondCharts[index]) {
                  try { this.secondCharts[index].destroy(); } catch (e) {
                    // skip
                  }
                  this.secondCharts[index] = null;
                }

                const dataSet = this.secondChartDataSets[index] || [];
                const minValue = Math.min(
                  ...dataSet.map((item) => item.longShortRatio)
                );
                const roundedValue = Math.floor(minValue / 0.05) * 0.05;
                const startValue =
                  minValue - roundedValue <= 0.05
                    ? roundedValue
                    : roundedValue + 0.05;

                this.secondCharts[index] = new ChartJS(ctx, {
                  type: "bar",
                  data: {
                    datasets: [
                      {
                        label: "Long/Short (Acc)",
                        type: "line",
                        data: dataSet,
                        borderColor: "rgba(0, 0, 0, 1)",
                        pointBackgroundColor: "rgba(255, 255, 255, 1)",
                        pointBorderColor: "rgba(0, 0, 0, 1)",
                        pointBorderWidth: 1.5,
                        pointRadius: 4,
                        pointHoverRadius: 6,
                        fill: true,
                        tension: 0.4,
                        borderWidth: 2,
                        yAxisID: "y-line",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                      {
                        label: "% Tài khoản Long",
                        data: dataSet.map((item) => ({ x: item.x, y: item.longPercent })),
                        backgroundColor: "rgba(0, 209, 112, 0.8)",
                        stack: "Stack 0",
                        yAxisID: "y-bar",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                      {
                        label: "% Tài khoản Short",
                        data: dataSet.map((item) => ({ x: item.x, y: item.shortPercent })),
                        backgroundColor: "rgba(231, 76, 60, 0.8)",
                        stack: "Stack 0",
                        yAxisID: "y-bar",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                    ],
                  },
                  options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        display: true,
                      },
                      datalabels: {
                        display: false,
                      },
                      title: {
                        display: true,
                        text: `Top Accounts(${this.getCoinName(this.coinNames[index])})`,
                      },
                      tooltip: {
                        callbacks: {
                          label: function (tooltipItem) {
                            const dataset = tooltipItem.dataset;
                            const rawData = dataset.meta.customValue;
                            const index = tooltipItem.dataIndex;
                            const shortPercent = rawData[index].shortPercent || 0;
                            const longPercent = rawData[index].longPercent || 0;
                            const longShortRatio =
                              rawData[index].longShortRatio || 0;
                            return `Long: ${longPercent}%\r\nShort: ${shortPercent}%\r\nLong Short Ratio: ${Number(longShortRatio).toFixed(3)}`;
                          },
                        },
                      },
                    },
                    scales: {
                      x: {
                        type: "time",
                        time: {
                          ...(this.periods === "1d" && {
                            round: "day",
                          }),
                          unit:
                            this.periods === "1h" || this.periods === "4h"
                              ? "hour"
                              : this.periods === "1d"
                                ? "day"
                                : "minute",
                        },
                        labels: dataSet.map((item) => item.x),
                        ticks: {
                          maxTicksLimit: 20,
                          ...(this.periods !== "1d" && {
                            stepSize:
                              this.periods === "1h"
                                ? 1
                                : this.periods === "4h"
                                  ? 4
                                  : 5,
                          }),
                          callback: function (value) {
                            const date = new Date(value);
                            if (periods === "1d") {
                              return date.toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                              });
                            } else {
                              return date.toLocaleTimeString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                              });
                            }
                          },
                        },
                        stacked: true,
                      },
                      "y-line": {
                        id: "y-line",
                        position: "right",
                        grid: {
                          drawOnChartArea: false,
                        },
                        beginAtZero: false,
                        min: startValue,
                        ticks: {
                          callback: function (value) {
                            return value.toFixed(2);
                          },
                        },
                      },
                      y: {
                        display: false,
                        grid: {
                          display: false,
                        },
                      },
                    },
                  },
                });
              }
            });

          this.thirdChartIds
            .slice(0, this.totalChart)
            .forEach((chartId, index) => {
              const canvas = document.getElementById(chartId);
              if (!canvas) return;
              if (canvas.offsetParent === null) return;
              const exist = ChartJS.getChart(canvas);
              if (exist) {
                try { exist.destroy(); } catch (e) {
                  // skip
                }
              }
              const ctx = canvas.getContext("2d");
              if (!ctx) return;
              if (canvas) {
                if (this.thirdCharts[index]) {
                  try { this.thirdCharts[index].destroy(); } catch (e) {
                    // skip
                  }
                  this.thirdCharts[index] = null;
                }

                const dataSet = this.thirdChartDataSets[index] || [];
                const minValue = Math.min(
                  ...dataSet.map((item) => item.longShortRatio)
                );
                const roundedValue = Math.floor(minValue / 0.05) * 0.05;
                const startValue =
                  minValue - roundedValue <= 0.05
                    ? roundedValue
                    : roundedValue + 0.05;

                this.thirdCharts[index] = new ChartJS(ctx, {
                  type: "bar",
                  data: {
                    datasets: [
                      {
                        label: "Long/Short (Vị thế)",
                        type: "line",
                        data: dataSet,
                        borderColor: "rgba(0, 0, 0, 1)",
                        pointBackgroundColor: "rgba(255, 255, 255, 1)",
                        pointBorderColor: "rgba(0, 0, 0, 1)",
                        pointBorderWidth: 1.5,
                        pointRadius: 4,
                        pointHoverRadius: 6,
                        fill: true,
                        tension: 0.4,
                        borderWidth: 2,
                        yAxisID: "y-line",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                      {
                        label: "% Vị thế Long",
                        data: dataSet.map((item) => ({ x: item.x, y: item.longPercent })),
                        backgroundColor: "rgba(0, 209, 112, 0.8)",
                        stack: "Stack 0",
                        yAxisID: "y-bar",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                      {
                        label: "% Vị thế Short",
                        data: dataSet.map((item) => ({ x: item.x, y: item.shortPercent })),
                        backgroundColor: "rgba(231, 76, 60, 0.8)",
                        stack: "Stack 0",
                        yAxisID: "y-bar",
                        meta: {
                          customValue: dataSet,
                        },
                      },
                    ],
                  },
                  options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                      legend: {
                        display: true,
                      },
                      datalabels: {
                        display: false,
                      },
                      title: {
                        display: true,
                        text: `Top Positions(${this.getCoinName(this.coinNames[index])})`,
                      },
                      tooltip: {
                        callbacks: {
                          label: function (tooltipItem) {
                            const dataset = tooltipItem.dataset;
                            const rawData = dataset.meta.customValue;
                            const index = tooltipItem.dataIndex;
                            const shortPercent = rawData[index].shortPercent || 0;
                            const longPercent = rawData[index].longPercent || 0;
                            const longShortRatio =
                              rawData[index].longShortRatio || 0;
                            return `Long: ${longPercent}%\r\nShort: ${shortPercent}%\r\nLong Short Ratio: ${Number(longShortRatio).toFixed(3)}`;
                          },
                        },
                      },
                    },
                    scales: {
                      x: {
                        type: "time",
                        time: {
                          ...(this.periods === "1d" && {
                            round: "day",
                          }),
                          unit:
                            this.periods === "1h" || this.periods === "4h"
                              ? "hour"
                              : this.periods === "1d"
                                ? "day"
                                : "minute",
                        },
                        labels: dataSet.map((item) => item.x),
                        ticks: {
                          maxTicksLimit: 20,
                          ...(this.periods !== "1d" && {
                            stepSize:
                              this.periods === "1h"
                                ? 1
                                : this.periods === "4h"
                                  ? 4
                                  : this.periods === "15m"
                                    ? 15
                                    : 5,
                          }),
                          callback: function (value) {
                            const date = new Date(value);
                            if (periods === "1d") {
                              return date.toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "2-digit",
                              });
                            } else {
                              return date.toLocaleTimeString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                              });
                            }
                          },
                        },
                        stacked: true,
                      },
                      "y-line": {
                        id: "y-line",
                        position: "right",
                        grid: {
                          drawOnChartArea: false,
                        },
                        beginAtZero: false,
                        min: startValue,
                        ticks: {
                          callback: function (value) {
                            return value.toFixed(2);
                          },
                        },
                      },
                      y: {
                        display: false,
                        grid: {
                          display: false,
                        },
                      },
                    },
                  },
                });
              }
            });

        });
      });
    },
    handleMetrics(list) {
      this.selectedMetrics = Array.isArray(list) ? list : [];
    }
  },
  beforeUnmount() {
    const killArr = (arr) => (arr || []).forEach(c => {
      try { c?.destroy(); } catch (e) {
        // skip
      }
    });
    killArr(this.charts);
    killArr(this.secondCharts);
    killArr(this.thirdCharts);

    this.charts = this.secondCharts = this.thirdCharts = [];
  },

  deactivated() {
    const killArr = (arr) => (arr || []).forEach(c => {
      try { c?.destroy(); } catch (e) {
        // skip
      }
    });
    killArr(this.charts);
    killArr(this.secondCharts);
    killArr(this.thirdCharts);
  }
};
</script>
